// Import React Library
import React, { useRef, useState } from 'react';

// Import TextFields
import TextField from '@mui/material/TextField';

// Import Email.js Library
import emailjs from '@emailjs/browser';

// Import Alerts
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

// Import Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

// Import React Reveal
import { Fade } from "react-awesome-reveal";

// Contact Component (versión GA4 con gtag.js directo)
const Contact = () => {
  // Ref del formulario
  const form = useRef();

  // Inputs
  const [userName , setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [formMessage, setFormMessage] = useState('');
  const [userSize , setUserSize] = useState('');
  const [userPhone , setUserPhone] = useState('');
  const [userSubject , setUserSubject] = useState('');

  // UI de feedback
  const [successMessage , setSuccessMessage] = useState(false);
  const [errorMessage , setErrorMessage] = useState(false);
  const [alertMessage , setAlertMessage] = useState('');

  const [open, setOpen] = React.useState(false);
  const [error, setError] = React.useState(false);

  const [selectedKey, setSelectedKey] = useState(0);

  const handleClick = () => setOpen(true);
  const handleError = () => setError(true);
  const handleClose = (_e, reason) => { if (reason !== 'clickaway') setOpen(false); };
  const handleErrorClose = (_e, reason) => { if (reason !== 'clickaway') setError(false); };

  // Send email function
  const sendContactEmail = (e) =>{
    e.preventDefault();

    // Validación simple
    if (userName === '' || userEmail === '' || formMessage === '' || userPhone === '') {
      setAlertMessage('Debe completar todos los campos del formulario');
      setErrorMessage(true);
      setSuccessMessage(false);
      handleError();

      setTimeout(() =>{
        setErrorMessage(false);
        setSuccessMessage(false);
      }, 3000);
      return;
    }

    // Envío con EmailJS
    emailjs
      .sendForm('service_7578jaz', 'template_a63j8by', form.current, {
        publicKey: 'pxLmwp6Ex0LEGM1zq'
      })
      .then(
        () => {
          // ✅ Éxito visual
          setAlertMessage('¡Muchas gracias, su mensaje ha sido enviado con éxito!');
          handleClick();
          setErrorMessage(false);
          setSuccessMessage(true);

          // ✅ Limpieza de campos
          setUserEmail('');
          setUserName('');
          setFormMessage('');
          setUserSubject('');
          setUserPhone('');
          setUserSize('');
          setSelectedKey(prevKey => prevKey + 1);

          setTimeout(() =>{
            setErrorMessage(false);
            setSuccessMessage(false);
          }, 3000);
        },
        (error) => {
          // Error visual
          setAlertMessage(error.text);
          setErrorMessage(true);
          setSuccessMessage(false);
        },
      );
  };

  return (
    <div id="contact-form" className='contact-form'>
      {/* Snackbar éxito */}
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" variant="filled" sx={{ width: '100%' }}>
          ¡Muchas gracias, su mensaje ha sido enviado con éxito!
        </Alert>
      </Snackbar>

      {/* Snackbar error */}
      <Snackbar open={error} autoHideDuration={6000} onClose={handleErrorClose}>
        <Alert onClose={handleErrorClose} severity="error" variant="filled" sx={{ width: '100%' }}>
          Debe completar todos los campos del formulario.
        </Alert>
      </Snackbar>

      <h2 className='text-gray-800' id='contactFormTitle'>
        SOLICITAR COTIZACIÓN <FontAwesomeIcon icon={faEnvelope} className='contact-icon'/>
      </h2>
      <span className='span-title'></span>

      <div className='contact-container'>
        <form ref={form} onSubmit={sendContactEmail} className='contact-form' id="contactForm">
          { successMessage ? 
            <Alert variant="outlined" severity="success" className='form-alert'>
              {alertMessage}.
            </Alert> : ''
          }
          { errorMessage ? 
            <Alert variant="outlined" severity="error" className='form-alert'>
              {alertMessage}.
            </Alert> : ''
          }

          <div className='form-container'>
            <TextField
              className='input-text'
              id="standard-multiline-flexible user-name"
              label="Nombre"
              multiline
              maxRows={4}
              variant="standard"
              name="user_name"
              onChange={(e) => setUserName(e.target.value)}
              value={userName}
            />
          </div>

          <div className='form-container'>
            <TextField
              className='input-text'
              id="standard-multiline-flexible user-email"
              label="Email"
              multiline
              maxRows={4}
              variant="standard"
              name="user_email"
              onChange={(e) => setUserEmail(e.target.value)}
              value={userEmail}
            />
          </div>

          <div className='form-container'>
            <TextField
              className='input-text'
              id="standard-multiline-flexible user-phone"
              label="Teléfono"
              multiline
              maxRows={4}
              variant="standard"
              name="user_phone"
              onChange={(e) => setUserPhone(e.target.value)}
              value={userPhone}
            />
          </div>

          <div className='form-container'>
            <TextField
              className='input-text text-area'
              id="standard-multiline-flexible form-message"
              label="Mensaje"
              multiline
              maxRows={10}
              variant="standard"
              name="message"
              onChange={(e) => setFormMessage(e.target.value)}
              value={formMessage}
            />
          </div>

          <Fade direction='right' triggerOnce={true}>
            <button className="contact-button bg-gray-800 text-white hover:bg-gray-600">
              <div>Enviar</div>
            </button>
          </Fade>
        </form>
      </div>
    </div>
  );
};

export default Contact;
